import type { FireworksHandlers } from '@fireworks-js/react';
import { Fireworks } from '@fireworks-js/react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '#pie/utils/TailwindUtils';
import { Text } from '../text/Text';

export const HappyNewYear = () => {
  const { t } = useTranslation();
  const ref = useRef<FireworksHandlers>(null);
  const [runAnimation, setRunAnimation] = useState(true);

  const handleDismiss = () => {
    setRunAnimation(false);
    if (ref.current?.isRunning) {
      ref.current.stop();
    }
    ref.current?.clear();
  };

  return (
    <>
      {runAnimation && (
        <button
          onClick={handleDismiss}
          className="inset-0 fixed w-screen h-screen z-50 cursor-pointer"
          type="button"
        >
          <Fireworks
            data-testid="fireworks"
            ref={ref}
            options={{ particles: 100 }}
            className={cn(
              'inset-0 fixed w-screen h-screen transition-all duration-1000 z-50',
              runAnimation ? 'bg-black/80' : 'bg-transparent',
            )}
          >
            <div className="fixed inset-0 flex items-center justify-center mx-auto max-w-5xl px-8">
              <Text
                className={cn(
                  'text-center z-50 text-warning text-5xl italic leading-normal',
                  runAnimation ? 'opacity-100' : 'opacity-0 ',
                )}
                variant="h1"
                as="h1"
              >
                {t('fireworks.description')}
              </Text>
            </div>
          </Fireworks>
        </button>
      )}
    </>
  );
};
